import { useObservableState } from "observable-hooks";
import { useEffect, useState } from "react";
import { debounceTime } from "rxjs/operators";

export const useDebouncedInput = () => {
  const [value, setValue] = useState<string>("");
  const [debouncedValue, setDebouncedInput] = useObservableState(
    (input$) => input$.pipe(debounceTime(300)),
    value
  );

  useEffect(() => setDebouncedInput(value), [value]);

  return {
    value,
    setValue,
    debouncedValue,
  };
};
